

  <script setup>
  import { ref } from 'vue';
  import { ElDialog } from 'element-plus'
  import 'element-plus/dist/index.css'
  const dialogVisible = ref(false)
  // 使用 ref 创建响应式数据
  const seleIndex = ref(0)
  const handleClose=()=>{

  }
  const openDialog = ()=>{
    dialogVisible.value = true
    console.log(dialogVisible.value,'==============')
  }
  </script>
  <template>
    <div>
        <div class="usThomse1">
        <p style="width: 100%; height: 1px;"></p>
        <img class="usBg" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/usBg.png" alt="">
        <div class="usCenter">
            <p class="usMess">了解我们一下</p>
            <p class="usTit">青碳行平台</p>
            <p class="usText">“青碳行”是在行业主管部门指导下，根据国家“碳达峰、碳中和”战略和“健康中国2030”规划纲要，结合数字人民币试点，推出的全国首个以数字人民币结算的碳普惠平台。该平台以区块链技术为依托，将用户的地铁、公交、骑行、新能源车等绿色低碳出行行为核算为碳减排量，通过隐私算法保护用户隐私和数据安全，以“长数链”区块链技术全生命周期存证碳资产，并引入数字人民币作为计价和支付手段，实现公众绿色低碳出行可量、可视和可得，利用市场化手段激励公众日常出行、生活领域节能降碳，倡导简约适度、绿色低碳、健康的生产生活方式，推动低碳产业发展。</p>
            <p @click="openDialog" class="usBott">立即下载</p>
        </div>
    </div>
    <!-- 探索碳普惠创新模式 -->
    <div class="usThomse2">
        <div class="us2Title">
            <p class="us2Mess">了解我们一下</p>
            <p class="us2Tit">探索碳普惠创新模式</p>
        </div>
        <div class="us2Center">
            <img class="us2list1" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us2list1.png" alt="">
            <img class="us2list1" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us2list2.png" alt="">
            <img class="us2list1" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us2list3.png" alt="">
            <img class="us2list1" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us2list4.png" alt="">
            <img class="us2list1" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us2list5.png" alt="">
        </div>
    </div>
    <!-- 助力绿色低碳双循环发展 -->
    <div class="usThomse3">
        <div class="us2Title">
            <p class="us2Mess">了解我们一下</p>
            <p class="us2Tit">助力绿色低碳双循环发展</p>
        </div>
        <div class="us3Center">
            <img class="us3Bg" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us3Bg.png" alt="">
            <div class="us3Cen">
                <div class="us3CenLeft">
                    <div @mouseover="seleIndex = 0" :class="seleIndex===0?'us3LeftList':'us3LeftListHui'">
                        <p class="us3Tit">引领公众低碳生活</p>
                        <p class="us3Mess2">让绿色低碳生活成为全民运动</p>
                        <img v-if="seleIndex===0" class="us3GoIcon" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us3GoIcon.png" alt="">
                        <p v-if="seleIndex===1" style="width:50px;height: 50px; margin-top: -7px;"></p>
                    </div>
                    <div @mouseover="seleIndex = 1" style="margin-top: 5px;" :class="seleIndex===1?'us3LeftList':'us3LeftListHui'">
                        <p class="us3Tit">助力社会双碳目标</p>
                        <p class="us3Mess2">鼓励社会多方参与节能降碳</p>
                        <img v-if="seleIndex===1" class="us3GoIcon" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us3GoIcon.png" alt="">
                        <p v-if="seleIndex===0" style="width:50px;height: 50px; margin-top: -7px;"></p>
                    </div>
                </div>
                <div v-if="seleIndex === 0" class="us3CenRight">
                    <div class="us3Top">
                        <div class="us3Left">
                            <div class="useRigTxt">
                                <p class="useRigTit">用户群广</p>
                                <p class="useRigMess">低碳无门槛</p>
                            </div>
                        </div>
                        <div class="us3Right">
                            <div class="useRigTxt">
                                <p class="useRigTit">活跃度高</p>
                                <p class="useRigMess">绿色添活力</p>
                            </div>
                        </div>
                    </div>
                    <div class="us3Bott">
                        <div class="useRigTxt">
                            <p class="useRigTit">影响力大</p>
                            <p class="useRigMess">低碳出行场景全覆盖</p>
                        </div>
                    </div>
                </div>
                <div v-if="seleIndex === 1" class="us3CenRight2">
                    <div class="us3Bott">
                        <div class="useRigCenter">
                            <img class="us3topBg" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us3topBg4.png" alt="">
                            <img class="us3topBg" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us3topBg5.png" alt="">
                        </div>
                        <div class="useRigTxt">
                            <p class="useRigTit">助力碳中和</p>
                            <p class="useRigMess">积累的用户碳减排量用于企业、政府及大型活动碳中和</p>
                        </div>
                    </div>
                    <div class="us3Bott">
                        <div class="useRigTxt">
                            <p class="useRigTit">履行ESG披露</p>
                            <p class="useRigMess">发布ESG，倡导企业生产内部化的外部影响，实现社会责任履约</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <el-dialog
        :show-close="false"
        v-model="dialogVisible"
        width="500"
        :before-close="handleClose"
        title=""
    >
      <div class="codeCenter">
        <img class="codeImg" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/codeImg.png" alt="">
        <img @click="dialogVisible = false" class="dialogClose" src="https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/dialogClose.png" alt="">
      </div>
    </el-dialog>
</div>

  </template>
  <style lang="less" scoped>
  p{
    margin: 0;
  }
  .codeCenter{
    border: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: rgba(#000,0);

    .codeImg{
      width: 50%;
    }
    .dialogClose{
      width: 40px;
      margin-top: 40px;
    }
  }
  /deep/ .el-dialog{
    background: rgba(0,0,0,0) !important;
    --el-dialog-box-shadow:none !important;
    z-index: 2000 !important; /* 确保这个值高于页面上其他元素的 z-index */
  }
    @keyframes grow {
        from {
            transform: scale(1); /* 初始大小 */
        }
        to {
            transform: scale(1.03); /* 放大到1.5倍 */
        }
    }
    @keyframes grow1 {
        from {
            transform: scale(1.03); /* 放大到1.5倍 */
        }
        to {
            transform: scale(1); /* 初始大小 */

        }
    }
    .usThomse1{
        margin-top: -3px;
        position: relative;
        .usBg{
            width: 100%;
        }
        .usCenter{
            position: absolute;
            z-index: 9;
            width: 26.5%;
            left: 57%;
            top: 25%;
            text-align: left;
        }
        .usMess{
            font-size: 18px;
            color: #00BB98;
            text-align: left;
        }
        .usTit{
            font-size: 33px;
            color: #000B33;
            font-weight: 300;
            margin: 15px 0;
            margin-bottom: 17px;
        }
        .usText{
            font-size: 14.5px;
            line-height: 25px;
            font-weight: 300;
            color: #000B33;
            text-align: justify;
            letter-spacing: 1px;
        }
        .usBott{
            width: 140px;
            height: 46px;
            background: #00BB98;
            color: #fff;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 30px;
            margin-top: 15px;
            cursor: pointer;
        }
    }
    .usThomse2{
        width: 84%;
        margin: 60px auto 0;

        .us2Center{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 20px;
            .us2list1{
                cursor: pointer;
                width: 19%;
                animation: grow1 0.5s ease-in-out forwards; /* 应用动画并设置为无限次播放 */
            }
            .us2list1:hover{
                animation: grow 0.5s ease-in-out forwards; /* 应用动画并设置为无限次播放 */
            }
        }

    }
    .usThomse3{
        width: 100%;
        margin: 60px auto 0;
        .us2Title{
            width: 82%;
        }
        .us3Center{
            width: 100%;
            height: 100%;
            margin-top: 20px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            .us3Cen{
                width: 84%;
                height: 100%;
                z-index: 9;
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                display: flex;
                align-items: center;
                justify-content: space-between;
                @keyframes example {
                    from{
                        transform: scale(1);
                    }
                    to{
                        transform: scale(1.01);
                    }
                }
                .us3CenLeft{
                    width: 38%;
                    text-align: left;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    margin-top: -5%;
                    margin-left: 20px;
                    // background: red;
                    // align-items: center;

                    .us3LeftList{
                        cursor: pointer;
                        animation-name: example; /* 引用关键帧 */
                        animation-duration: 0.5s; /* 动画持续时间 */
                        animation-fill-mode:forwards;
                        .us3Tit{
                            font-size: 22px;
                            color: #00BB98;
                        }
                        .us3Mess1{
                            font-size: 14px;
                            color: #484848;
                            font-weight: 300;
                            letter-spacing: 6px;
                            margin-top: 6px;
                        }
                        .us3Mess2{
                            width: 80%;
                            font-size: 14px;
                            color: #484848;
                            font-weight: 300;
                            margin-top: 3px;
                        }
                    }

                    .us3LeftListHui{
                        cursor: pointer;

                        .us3Tit{
                            font-size: 22px;
                            color: rgba(#000B33, 0.4);
                            font-weight: 500;
                        }
                        .us3Mess1{
                            font-size: 14px;
                            font-weight: 300;
                            margin-top: 6px;
                            color: rgba(#000B33, 0.3);
                            letter-spacing: 6px;
                        }
                        .us3Mess2{
                            width: 80%;
                            font-size: 14px;
                            color: rgba(#000B33, 0.3);
                            font-weight: 300;
                            margin-top: 3px;
                        }
                    }
                    .us3GoIcon{
                        width: 50px;
                        margin-top: -7px;
                    }
                }
                .us3CenRight2{
                    width: 64%;
                    height: 100%;
                    color: #fff;
                    .useRigTxt{
                        position: absolute;
                        left: 10px;
                        bottom: 13px;
                        text-align: left;
                        .useRigTit{
                            font-size: 24px;
                        }
                        .useRigMess{
                            font-size: 13px;
                            color: rgba(#fff, 0.7);
                            margin-top: 3px;
                            margin-left: 3px;
                        }
                    }
                    .us3Bott{
                        width: 100%;
                        height: 50%;
                        display: flex;
                        background: url('https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us3topBg31.png');
                        background-size: 100% auto;
                        position: relative;
                        cursor: pointer;
                        .useRigCenter{
                            width: 100%;
                            position: absolute;
                            top: 0;
                            left: 0;
                            .us3topBg{
                                width: 50%;
                            }
                        }
                    }
                    .us3Bott:hover{
                        animation: grow 0.5s ease-in-out forwards; /* 应用动画并设置为无限次播放 */
                    }
                    .us3Top{
                        width: 100%;
                        height: 50%;
                        display: flex;
                        .us3Left{
                            width: 50%;
                            height: 100%;
                            background: url('https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us3topBg1.png');
                            background-size: 100% 100%;
                            position: relative;
                            cursor: pointer;
                        }
                        .us3Left:hover{
                            animation: grow 0.5s ease-in-out forwards; /* 应用动画并设置为无限次播放 */
                        }
                        .us3Right{
                            width: 50%;
                            height: 100%;
                            background: url('https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us3topBg2.png');
                            background-size: 100% 100%;
                            position: relative;
                            cursor: pointer;
                        }
                        .us3Right:hover{
                            animation: grow 0.5s ease-in-out forwards; /* 应用动画并设置为无限次播放 */
                        }
                    }
                }
                .us3CenRight{
                    width: 64%;
                    height: 100%;
                    color: #fff;
                    .useRigTxt{
                        position: absolute;
                        left: 10px;
                        bottom: 13px;
                        text-align: left;
                        .useRigTit{
                            font-size: 24px;
                        }
                        .useRigMess{
                            font-size: 13px;
                            color: rgba(#fff, 0.7);
                            margin-top: 3px;
                            margin-left: 3px;
                        }
                    }
                    // background: #00BB98;
                    .us3Bott{
                        width: 100%;
                        height: 50%;
                        display: flex;
                        background: url('https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us3topBg3.png');
                        background-size: 100% 100%;
                        position: relative;
                        cursor: pointer;
                    }
                    .us3Bott:hover{
                        animation: grow 0.5s ease-in-out forwards; /* 应用动画并设置为无限次播放 */
                    }
                    .us3Top{
                        width: 100%;
                        height: 50%;
                        display: flex;
                        .us3Left{
                            width: 50%;
                            height: 100%;
                            background: url('https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us3topBg1.png');
                            background-size: 100% 100%;
                            position: relative;
                            cursor: pointer;
                        }
                        .us3Left:hover{
                            animation: grow 0.5s ease-in-out forwards; /* 应用动画并设置为无限次播放 */
                        }
                        .us3Right{
                            width: 50%;
                            height: 100%;
                            background: url('https://carbonh5.oss-cn-qingdao.aliyuncs.com/qtx/officialWebsite/us3topBg2.png');
                            background-size: 100% 100%;
                            position: relative;
                            cursor: pointer;
                        }
                        .us3Right:hover{
                            animation: grow 0.5s ease-in-out forwards; /* 应用动画并设置为无限次播放 */
                        }
                    }
                }
            }
            .us3Bg{
                width: 100%;
                // top: 0;
                // left: 0;
                position: relative;
                z-index: 0;
            }
        }
    }
    .us2Title{
        width: 96%;
        margin: 30px auto 0;
        text-align: left;
        .us2Mess{
            font-size: 18px;
            color: #00BB98;
            text-align: left;
        }
        .us2Tit{
            font-size: 32px;
            color: #000B33;
            font-weight: 300;
            margin-top: 8px;
        }
    }
  </style>